import * as React from 'react';
import * as _ from 'underscore';

import {
  CardPositionContext,
  ContentInfoContext,
} from '../../app/contexts/TelemetryContexts';
import { ConnectedContentCardWrapper } from '../../app/spaces/CardView/ConnectedContentCardWrapper';
import { SpaceInfo } from '../../app/state/SpaceInfo';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { ShowMoreCardsAction } from '../actions/ShowMoreCardsAction';
import { ChannelStyles } from '../styles/ChannelStyles';
import { ChannelTypes } from '../types/ChannelTypes';
import { Channel } from './Channel';

export interface ContentInfoChannelBaseProps {
  readonly channelType: ChannelTypes;
  readonly title: string;
  readonly list: ReadonlyArray<IContentInfo>;
  readonly seeAllUrl: string;
  readonly seeAllAltText: string;
  readonly showLastAccessedAt?: boolean;
  readonly isFetching: boolean;
  readonly numRows: number;
  readonly spaceInfo: SpaceInfo;
  readonly shouldListWrapVertically?: boolean;
}

export interface ContentInfoChannelOwnProps {
  readonly maxCardsPerRow: number;
  readonly channelType?: ChannelTypes;
  readonly numCardsToShow?: number;
  readonly title?: string;
  readonly headerIconPath?: string;
  readonly showMoreCards?: (numCardsToShow: number, channelType: ChannelTypes) => ShowMoreCardsAction;
}

export type ContentInfoChannelProps = ContentInfoChannelBaseProps & ContentInfoChannelOwnProps;

export class ContentInfoCardChannel extends React.PureComponent<ContentInfoChannelProps> {

  calculateMaxNumCards = () => {
    let maxNumCards: number;
    if (this.props.numCardsToShow > 0) {
      // If numCardsToShow was passed as > 0, show that many cards
      maxNumCards = this.props.numCardsToShow;
    } else {
      // If numCardsToShow wasn't passed or is passed as 0, use the full grid calculation
      maxNumCards = this.props.maxCardsPerRow * this.props.numRows;
    }
    return maxNumCards;
  }

  render() {
    const maxNumCards = this.calculateMaxNumCards();

    let cards = this.props.list.slice(0, maxNumCards).map((contentInfo: IContentInfo, id: number) => {
        return (
          <React.Fragment key={`${contentInfo.contentType}:${contentInfo.id}:${this.props.channelType}`}>
            <ContentInfoContext.Provider value={contentInfo}>
              <CardPositionContext.Provider value={id + 1}>
                <div className={ChannelStyles.cardDimensions}>
                  <ConnectedContentCardWrapper
                    content={contentInfo}
                    showActionMenu={true}
                    showLastAccessedAt={this.props.showLastAccessedAt}
                    forDragPreview={false}
                    dragInProgress={false}
                    setIsDragging={_.noop}
                  />
                </div >
              </CardPositionContext.Provider>
            </ContentInfoContext.Provider>
          </React.Fragment>
        );
    });

    return (
      <Channel
        numCards={maxNumCards}
        {...this.props}
      >
        {cards}
      </Channel>
    );
  }
}
